import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function AccordionHeader({ isOpen, toggle, className = '', accordionId = '', children }) {
  const handleClick = (event) => {
    event.preventDefault();
    toggle();
  };

  return (
    <ButtonWithIcon
      type="link"
      sprite={isOpen ? 'ChevronUp' : 'ChevronDown'}
      size="small"
      className={`u-els-font-size-body-large u-els-margin-top-1x u-els-margin-bottom-1x ${className}`}
      onClick={handleClick}
      aria-expanded={isOpen}
      aria-controls={accordionId}>
      {children}
    </ButtonWithIcon>
  );
}

AccordionHeader.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  accordionId: PropTypes.string,
  children: PropTypes.node,
};

export default AccordionHeader;
